import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between bg-gray-500 px-4 py-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl" }, "Invoice Controls", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_print_invoice = _resolveComponent("print-invoice")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_print_invoice)
  ]))
}